import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import HeadingCp from '../components/HeadingCp';
import { useNavigate } from 'react-router-dom';

const MaintenanceEstimateList = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [estimates, setEstimates] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchEstimates();
    // eslint-disable-next-line
  }, []);

  const fetchEstimates = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${apiUrl}/contracts_crud.php?getMaintenanceEstimates=true`);
      console.log(response.data);
      if (response.data[0] === 'success') {
        setEstimates(response.data[1]);
      } else if (response.data.success && Array.isArray(response.data.success)) {
        setEstimates(response.data.success);
      } else {
        toast.error('Failed to load estimates.', { position: 'top-center' });
      }
    } catch {
      toast.error('Error loading estimates.', { position: 'top-center' });
    }
    setLoading(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this estimate?')) return;
    try {
      const response = await axios.post(`${apiUrl}/contracts_crud.php`, {
        status: 'deleteMaintenanceEstimate',
        data: { id }
      });
      if (response.data === 'success' || response.data.success) {
        toast.success('Estimate deleted', { position: 'top-center' });
        setEstimates(estimates.filter(e => e.id !== id));
      } else {
        toast.error('Failed to delete estimate.', { position: 'top-center' });
      }
    } catch {
      toast.error('Error deleting estimate.', { position: 'top-center' });
    }
  };

  return (
    <div className="mx-auto max-w-6xl px-4 py-10">
      <HeadingCp label="Maintenance Estimates List" />
      <div className="mb-6 flex justify-end">
        <button
          className="px-4 py-2 bg-blue-600 text-white rounded shadow hover:bg-blue-700"
          onClick={() => navigate('/maintenance-estimate/new')}
        >
          + New Estimate
        </button>
      </div>
      <div className="overflow-x-auto border rounded shadow bg-white">
        {loading ? (
          <div className="text-center py-10 text-gray-500">Loading...</div>
        ) : (
          <table className="min-w-full text-sm">
            <thead>
              <tr className="bg-gray-100">
                <th className="p-2 text-left">ID</th>
                <th className="p-2 text-left">Job Site</th>
                <th className="p-2 text-left">Contact</th>
                <th className="p-2 text-left">Phone</th>
                <th className="p-2 text-left">Panel Type</th>
                <th className="p-2 text-left">System Type</th>
                <th className="p-2 text-left">Hourly Rate</th>
                <th className="p-2 text-left">Actions</th>
              </tr>
            </thead>
            <tbody>
              {estimates.length === 0 ? (
                <tr>
                  <td colSpan={8} className="p-4 text-center text-gray-400">
                    No estimates found.
                  </td>
                </tr>
              ) : (
                estimates.map((e) => (
                  <tr key={e.id} className="border-t">
                    <td className="p-2">{e.id}</td>
                    <td className="p-2">{e.job_site}</td>
                    <td className="p-2">{e.contact_name}</td>
                    <td className="p-2">{e.contact_phone}</td>
                    <td className="p-2">{e.panel_type}</td>
                    <td className="p-2">{e.system_type}</td>
                    <td className="p-2">${Number(e.hourly_rate).toLocaleString(undefined, {minimumFractionDigits:2})}</td>
                    <td className="p-2 space-x-2">
                      <button
                        onClick={() => navigate(`/maintenance_estimate/${e.id}`)}
                        className="text-green-700 hover:underline"
                      >
                        View
                      </button>
                      <button
                        onClick={() => handleDelete(e.id)}
                        className="text-red-600 hover:underline"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default MaintenanceEstimateList;
